import React from 'react';
import { Input } from '@vds/inputs';
import { InHomeUtils } from './../util/inhomeUtils';
export default class Email extends React.PureComponent {

    onChangeHandler = (e) => {
      let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      let pattern1 =/^[a-zA-Z0-9\s@._-]*$/;
    
        if (pattern.test(e.target.value) && pattern1.test(e.target.value)) {
          this.props.updateEmail({
            value: e.target.value,
            id: e.target.id,
            isValidMail: true,
            eMailErr: ""
          });
        } else {
          this.props.updateEmail({
            value: e.target.value,
            id: e.target.id,
            isValidMail: false,
            eMailErr: ""
          });
        }
      };
      
      onBlurHandler = (e) => {
        let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        let pattern1 =/^[a-zA-Z0-9\s@._-]*$/;
    
        if (!(pattern.test(e.target.value) && pattern1.test(e.target.value) )) {
          this.props.updateEmail({
            value: e.target.value,
            id: e.target.id,
            isValidMail: false,
            eMailErr: "Invalid email address."
          });
        }else {
          if(this.props.onBlurReturn){
            this.props.updateEmail({
              value: e.target.value,
              id: e.target.id,
              isValidMail: true,
              eMailErr: "",
              from: 'blur'
            });
          }
        }
      };

    onKeyPresshandler = (e, inputpattern) => {
        if ((e.key).match(inputpattern)) {
            return true;
        }
        else {
            e.preventDefault();
        }
    }

    preventCutCopyPasteHandler = (e) => {
        e.preventDefault();
        return false;
    }

    
    render() {
        const isFiOSFlag = sessionStorage?.getItem('fiosReferralFlow');
        let renderEmail = ([
            <label htmlFor={this.props.id}>{!this.props.hideStar && <strong className="required-mark">*</strong>}{this.props.label}</label>,
            <input aria-invalid="false"
                autoComplete={isFiOSFlag ? "off" : ''}
                type="email" name="email" id={this.props.id}
                placeholder={this.props.placeholder}
                tabIndex={this.props.tabIndex}
                className={this.props.className}
                onClick={this.props.OnClick}
                onChange={this.onChangeHandler}
                onCut={this.onChangeHandler}
                onPaste={this.onChangeHandler}
                onCopy={this.preventCutCopyPasteHandler}
                onKeyPress={(e) => this.onKeyPresshandler(e, /^[a-zA-Z0-9\s@._-]*$/)}
                ref={(ele) => this.props.updateEmailInputRef ? this.props.updateEmailInputRef(ele) : ''}
                value={this.props.value}
                aria-required="true"
                disabled={this.props.disabled} data-cs-mask/>,
            <div role="alert"  aria-live="assertive" className={this.props.emailErr ? "margin-horiz-small text-alert-red bold " : "hide"}>Please enter a valid email address</div>,
        ]);
    let errorEmailText = this.props.emailErrorText &&  this.props.emailErrorText != "" ? this.props.emailErrorText : "Please enter a valid email address";
    if(InHomeUtils.isNotNull(this.props.vds) && this.props.vds && this.props.vds === true) {
        renderEmail = (
            <Input label = {this.props.label} aria-invalid="false"
                autoComplete={isFiOSFlag ? "off" : ''}
                type="email" name="email" inputId={this.props.id}
                tabIndex={this.props.tabIndex}
                className={this.props.className}
                onClick={this.props.onClick}
                onChange={this.onChangeHandler}
                onBlur={this.onBlurHandler}
                onCut={this.onChangeHandler}
                onPaste={this.onChangeHandler}
                onCopy={this.preventCutCopyPasteHandler}
                onKeyPress={(e) => this.onKeyPresshandler(e, /^[a-zA-Z0-9\s@._-]*$/)}
                ref={(ele) => this.props.updateEmailInputRef ? this.props.updateEmailInputRef(ele) : ''}
                value={this.props.value}
                aria-required="true"
                disabled={this.props.disabled} 
                error = {this.props.emailErr? true : false}
                errorText= {this.props.emailErr ? errorEmailText : "You must enter an email address"}
                helperText={this.props.helperText}
                success = {this.props.emailValidFlag}
                data-cs-mask
                helperTextPlacement={this.props.helperTextPlacement}
                required={this.props.required}
                />
        );
    }
        return (
            <React.Fragment>{renderEmail}</React.Fragment>
            
        );
    }
}